var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeData.examConfig && _vm.isSupport
    ? _c(
        "div",
        [
          _c("el-divider", [_vm._v("考试设置")]),
          _c(
            "el-form-item",
            { attrs: { label: "开启评分" } },
            [
              _c("el-switch", {
                on: { change: _vm.handleEnableScoreChange },
                model: {
                  value: _vm.activeData.examConfig.enableScore,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData.examConfig, "enableScore", $$v)
                  },
                  expression: "activeData.examConfig.enableScore",
                },
              }),
            ],
            1
          ),
          _vm.activeData.examConfig.enableScore
            ? _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "计分方式" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择计分方式" },
                          model: {
                            value: _vm.activeData.examConfig.scoringType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.activeData.examConfig,
                                "scoringType",
                                $$v
                              )
                            },
                            expression: "activeData.examConfig.scoringType",
                          },
                        },
                        [
                          _vm.selectFields.includes(_vm.activeData.typeId)
                            ? _c("el-option", {
                                attrs: { label: "唯一答案和分值", value: 1 },
                              })
                            : _vm._e(),
                          _vm.inputFields.includes(_vm.activeData.typeId)
                            ? _c("el-option", {
                                attrs: {
                                  label: "回答中包含答案即可得分",
                                  value: 2,
                                },
                              })
                            : _vm._e(),
                          _vm.inputFields.includes(_vm.activeData.typeId)
                            ? _c("el-option", {
                                attrs: {
                                  label: "回答与答案完全相同才得分",
                                  value: 3,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "分数" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, step: 0.1 },
                        model: {
                          value: _vm.activeData.examConfig.score,
                          callback: function ($$v) {
                            _vm.$set(_vm.activeData.examConfig, "score", $$v)
                          },
                          expression: "activeData.examConfig.score",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.selectFields.includes(_vm.activeData.typeId)
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "答案" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.activeData.examConfig.answer,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.activeData.examConfig,
                                    "answer",
                                    $$v
                                  )
                                },
                                expression: "activeData.examConfig.answer",
                              },
                            },
                            _vm._l(
                              _vm.activeData.config.options,
                              function (option) {
                                return _c("el-option", {
                                  key: option.value,
                                  attrs: {
                                    label: option.label,
                                    value: option.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.inputFields.includes(_vm.activeData.typeId)
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "答案" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入正确答案",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.activeData.examConfig.answer,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.activeData.examConfig,
                                  "answer",
                                  $$v
                                )
                              },
                              expression: "activeData.examConfig.answer",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c("el-divider", [_vm._v("选项设置")]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }